const getDefaultState = () => {
  return { }
}

const state = getDefaultState()

const mutations = {
  // 返回
  GO_BACK: (state, router) => {
    window.history.length > 1 ? router.go(-1) : router.push('/')
  }
}

const actions = {

}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}




// WEBPACK FOOTER //
// ./src/store/modules/utils.js